import { render, staticRenderFns } from "./DeliveryType.vue?vue&type=template&id=7732a1bc&scoped=true&"
import script from "./DeliveryType.vue?vue&type=script&lang=js&"
export * from "./DeliveryType.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryType.vue?vue&type=style&index=0&id=7732a1bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7732a1bc",
  null
  
)

export default component.exports
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QList,QItem,QItemSection,QRadio,QItemLabel});qInstall(component, 'directives', {Ripple});
